import type { DrawerIcon } from '@/types';
import type { FC, ReactNode } from 'react';

import CurrentStation from '@/assets/icons/current-station.svg?react';
import IncidentIcon from '@/assets/icons/incident.svg?react';
import NextStation from '@/assets/icons/next-station.svg?react';
import RouteIcon from '@/assets/icons/route-list.svg?react';
import StationIcon from '@/assets/icons/station-list.svg?react';
import TimeDeviation from '@/components/shared/time-deviation';

const DrawerDetailsRow: FC<{
  type: DrawerIcon;
  content: ReactNode | string | number;
  deviation?: number;
}> = ({ type, content, deviation }) => {
  const iconMapper = {
    station: <StationIcon className="size-6 fill-muted-foreground" aria-hidden />,
    route: <RouteIcon className="size-6 fill-muted-foreground" aria-hidden />,
    incident: <IncidentIcon className="size-6 fill-muted-foreground" aria-hidden />,
    'current-station': <CurrentStation className="size-6 fill-muted-foreground" aria-hidden />,
    'next-station': <NextStation className="size-6 fill-muted-foreground" aria-hidden />,
  };

  const icon = iconMapper[type];

  return (
    <div className="flex items-center gap-2">
      {icon}
      <span className="text-sm text-popover-foreground">{content}</span>
      {deviation !== undefined && <TimeDeviation time={deviation} className="p-0 min-w-7.5" />}
    </div>
  );
};

export default DrawerDetailsRow;
